export const isExitIntentAllowedAtPath = (
  urlPath: string,
  region: string,
  ignoredRegionHomepages: string[] = [],
  ignoredPathsEndingWith: string[] = []
) => {
  // return false if the url path is not provided
  if (!urlPath) return false

  // return false if the url path is the home page and the region is in the ignoredRegionHomepages
  if (
    urlPath === '/' &&
    ignoredRegionHomepages.length > 0 &&
    ignoredRegionHomepages
      .map((r) => r.toLowerCase())
      .includes(region.toLowerCase())
  ) {
    return false
  }

  // return false if the pagePath ends with any of the ignoredPathsEndingWith
  const normalizedPathLowerCase = urlPath
    .split('?')[0]
    .replace(/\/$/, '')
    .toLowerCase()
  if (
    ignoredPathsEndingWith.length > 0 &&
    ignoredPathsEndingWith.some((ignorePath) =>
      normalizedPathLowerCase.endsWith(ignorePath.toLowerCase())
    )
  ) {
    return false
  }

  return true
}
